import React from 'react';

import classes from './FlexColumn.module.scss';

const flexColumn = (props) => (
    <div className={[classes.FlexColumn, props.className].join(' ')}>
        {props.children}
    </div>
);

export default flexColumn;